import { Injectable } from "@angular/core";
import * as CubiqTS from "shared/cubiq-model-multi-asset";
import { BaseLookupService } from "../../impl/BaseLookupService";
import { ITimezoneLookupService } from "../ITimezoneLookupService";
import { LoggerService } from "@bfx/logger";
const logger = LoggerService.for(__dirname);

@Injectable()
export class TimezoneLookupService
  extends BaseLookupService<string, CubiqTS.TimeZoneImpl>
  implements ITimezoneLookupService
{
  constructor() {
    super(CubiqTS.TimeZoneImpl);
  }

  mapItem(item: CubiqTS.TimeZoneImpl): void {
    super.mapItem(item);
  }

  getItemKey(item: CubiqTS.TimeZoneImpl): string {
    return String(item.id);
  }

  getTimezone(id: string): CubiqTS.TimeZoneImpl {
    var timezone = this.getItem(id);
    return timezone;
  }

  getAllTimezones(): Array<CubiqTS.TimeZoneImpl> {
    return Array.from(this.myItemMap.values());
  }
}
